/**
 * Accepts a function arguments object and returns its contents as array
 *
 * @param args - The function arguments to be extracted
 * @returns The extracted dunction arguments
 */
export function argumentsToArray(args: IArguments): any[] {
    const result = [];
    for (let i = 0; i < args.length; i++) {
        const arg = args[i];
        result.push(arg);
    }
    return result;
}

/**
 * Remove all null and undefined values from a list.
 *
 * @param array - The array of values to filter
 * @returns All the values from the array that aren't null or undefined
 */
export function removeNullAndUndefinedValues<T>(array: ReadonlyArray<T | null | undefined>): T[] {
    return array.filter(value => value !== null && typeof value !== 'undefined') as T[];
}
